<template>
  <div id='welcome' >
    <div class='container d-flex flex-column'>
      <h3>What is in the poll this month?</h3>
      <h1>{{ location.name }}</h1>
      <a href='javascript: ' @click="howThisWorks">How does this work?</a>
      <div style='flex-grow: 2'></div>
      <div class='d-flex actions'>
        <img src="/icons/down.png" @click="next">
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'intro',
    props: ['location'],

    methods: {
      next(){
        this.$ga.event('Button', 'Click', 'Start'); 
        this.$emit('show-page', 'food');
      },

      howThisWorks(){
        this.$ga.event('Link', 'Click', 'How does this work?');
        window.location = "https://runawayrascals.com/how-this-works/"
      }
    }
}
</script>

<style lang="scss" scoped>
  #welcome {
    height: 100%;

    .container {
      padding-top: 40px;
      height: 100%;
      .actions {
        margin-bottom: 20px;
        span {cursor: pointer}
      }
    }
  
  }

  #welcome > div:last-child {margin-bottom: 20px}
  IMG {width: 120px; transition: width 0.3s; cursor: pointer;}
  IMG:hover {width: 135px}
  .actions {align-items: center}
  .actions > span {margin-left: 16px}

  @media (max-width: 767.98px) { 
    IMG {width: 80px; }  
    #welcome .container {padding-top: 20px}
  }
</style>